module.exports = __webpack_public_path__ + "img/raybearer.23e7a6a9.png";